import { pictureUrl } from './pictureUrl';

export const cmsData = {};
export function cmsPicture(name) {
  return props => `url(${pictureUrl(props.theme.cms[name])})`;
}
